/**
 * Address-form hints from the platform country catalog (KAN-1456).
 *
 * The backend runs the same postal-code check when the address lands on
 * an order (`services/addresses.py`). This copy is comfort — it tells the
 * customer while they type — never the gate.
 */

/** Does `postalCode` fit the country's catalog format? No format (or one
 * that does not compile) means "do not check", never "reject everything":
 * a false reject would stop an order, which is worse than no check. */
export function postalCodeMatches(
  postalCode: string,
  regex: string | null | undefined,
): boolean {
  if (!regex) return true;
  try {
    // The catalog stores Python patterns; the seeded ones use only syntax
    // both engines share. Anchored on both ends like `re.fullmatch`.
    return new RegExp(`^(?:${regex})$`).test(postalCode.trim());
  } catch {
    return true;
  }
}

/** Does the country write the postal code before the city ("110 00
 * Praha") rather than after it ("London SW1A 1AA")? Read from the
 * catalog's `address_format`; with no format the form keeps its generic
 * city → postal code order. */
export function postalCodeBeforeCity(
  addressFormat: string | null | undefined,
): boolean {
  if (!addressFormat) return false;
  const postal = addressFormat.indexOf("{postal_code}");
  const city = addressFormat.indexOf("{city}");
  return postal !== -1 && city !== -1 && postal < city;
}
